import { Pagination } from "@ir/ui";
import { PageFooter } from "@src/presentation/components/Layout/common";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import { usePurchasersData } from "@src/presentation/providers/PurchasersDataProvider";

export const PurchasersFooter = () => {
  const { total, page, limit, loading, setPage } = usePurchasersData();

  return (
    <ErrorBoundary>
      {total > limit ? (
        <PageFooter>
          <Pagination
            totalItems={total}
            itemsPerPage={limit}
            currentPage={page}
            onPageChange={setPage}
            isDisabled={loading}
          />
        </PageFooter>
      ) : null}
    </ErrorBoundary>
  );
};
